<template>
  <div v-loading="loading">
    <el-form label-position="top" label-width="90px">
      <el-form-item label="🛠️ 选择子流程" prop="text">
        <el-cascader ref="subprocessCascader" style="width: 100%;" size="small" :value="subprocessId" separator=" - "
          placeholder="选择子流程" :options="subprocessList" :props="cascaderProps" @change="onSubprocessChange">
        </el-cascader>
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item label="🙂 设置发起人" prop="text" class="line-mode">
        <el-radio-group v-model="nodeProps.initiatorType">
          <el-radio label="SELF">同主流程</el-radio>
          <el-radio label="ASSIGN_USER">指定人员</el-radio>
        </el-radio-group>
        <div v-if="nodeProps.initiatorType === 'ASSIGN_USER'" style="margin-top: 8px;">
          <el-button size="mini" icon="el-icon-plus" type="primary" @click="selectUser" round>选择人员</el-button>
          <member-items v-model="subInitiator"></member-items>
        </div>
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item label="✨ 多版本选择" prop="text" class="line-mode">
        <el-radio-group v-model="nodeProps.versionType">
          <el-radio label="LATEST">按最新版发起</el-radio>
          <el-radio label="BINDING">按绑定版本发起</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item label="⚙️ 可选配置" prop="text">
        <el-checkbox v-model="nodeProps.passFormData">传递表单数据
          <el-tooltip content="将主流程表单数据传递到子流程" placement="top">
            <i class="el-icon-question more-config-tip"></i>
          </el-tooltip>
        </el-checkbox>
        <el-checkbox v-model="nodeProps.asyncLaunch" style="margin-left: 16px;">异步发起子流程
          <el-tooltip content="子流程拥有独立事务，与主流程事务隔离" placement="top">
            <i class="el-icon-question more-config-tip"></i>
          </el-tooltip>
        </el-checkbox>
      </el-form-item>
    </el-form>
    <member-picker title="请选择人员" type="user" ref="memberPicker" :selected="subInitiator"
                @ok="selectedUser"/>
  </div>
</template>

<script>
import MemberPicker from '../../common/MemberPicker'
import MemberItems from '../MemberItems'

export default {
  name: 'SubprocessNodeConfig',
  inject: {
    $workflow: {},
    $workflowKey: {
      default: null
    }
  },
  components: {MemberPicker, MemberItems},
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      subprocessList: []
    }
  },
  computed: {
    nodeProps () {
      return this.$workflow.selectedNode.props
    },
    cascaderProps () {
      return {
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false
      }
    },
    subprocessId () {
      const subprocess = this.nodeProps.subprocess
      return subprocess ? subprocess.id : ''
    },
    subInitiator: {
      get () {
        const user = this.nodeProps.subInitiator
        return user ? [user] : []
      },
      set (val) {
        this.nodeProps.subInitiator = val && val.length > 0 ? val[0] : null
      }
    }
  },
  mounted () {
    this.getSubprocessList()
    this.initDefaultProps()
  },
  methods: {
    initDefaultProps () {
      const props = this.nodeProps
      if (!props.initiatorType) {
        this.$set(props, 'initiatorType', 'SELF')
      }
      if (props.passFormData === undefined) {
        this.$set(props, 'passFormData', true)
      }
      if (props.asyncLaunch === undefined) {
        this.$set(props, 'asyncLaunch', false)
      }
      if (props.subInitiator === undefined) {
        this.$set(props, 'subInitiator', null)
      }
    },
    selectUser () {
      this.$refs.memberPicker.show()
    },
    selectedUser (select) {
      this.subInitiator = select
    },
    getSubprocessList () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/flow/configure/approval/process',
        method: 'post',
        data: this.$qs.stringify({
          excludeFlowKey: this.$workflowKey
        })
      }).then(res => {
        this.subprocessList = res.data.result || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSubprocessChange () {
      const nodes = this.$refs.subprocessCascader.getCheckedNodes()
      if (nodes && nodes.length > 0) {
        const checkedNode = nodes[0]
        const data = Object.assign({}, checkedNode.data)
        const pathNodes = checkedNode.pathNodes
        data.processName = pathNodes.length > 1 ? pathNodes[pathNodes.length - 2].data.name : data.name
        this.$set(this.nodeProps, 'subprocess', data)
      } else {
        this.$set(this.nodeProps, 'subprocess', null)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .line-mode {
  .el-radio {
    width: 150px;
    margin: 5px;
  }
}

::v-deep .el-form-item__label {
  line-height: 25px;
}

::v-deep .el-divider--horizontal {
  margin: 10px 0;
}

.more-config-tip {
  color: #909399;
  cursor: help;
  &:hover {
    color: #409eff;
  }
}
</style>
